import { render, staticRenderFns } from "./channelinventorylogs.vue?vue&type=template&id=0c21a91d&scoped=true"
import script from "./channelinventorylogs.vue?vue&type=script&lang=js"
export * from "./channelinventorylogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21a91d",
  null
  
)

export default component.exports